import { zipObject } from 'lodash';

/**
 * Creates an object with all the keys provided filled with one value.
 */
export const fillObjectKeys = <K extends string, V>(keys: K[], value: V): Record<K, V> =>
  zipObject(keys, Array(keys.length).fill(value)) as Record<K, V>;
